import api from './api';

const assetAssignmentService = {
  // Get all assignments
  getAllAssignments: async (params = {}) => {
    try {
      const response = await api.get('/asset-assignments', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching asset assignments:', error);
      throw error;
    }
  },

  // Get assignment by ID
  getAssignmentById: async (id) => {
    try {
      const response = await api.get(`/asset-assignments/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching asset assignment:', error);
      throw error;
    }
  },

  // Create assignment
  createAssignment: async (data) => {
    try {
      const response = await api.post('/asset-assignments', data);
      return response.data;
    } catch (error) {
      console.error('Error creating asset assignment:', error);
      throw error;
    }
  },

  // Update assignment
  updateAssignment: async (id, data) => {
    try {
      const response = await api.put(`/asset-assignments/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating asset assignment:', error);
      throw error;
    }
  },

  // Delete assignment
  deleteAssignment: async (id) => {
    try {
      const response = await api.delete(`/asset-assignments/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting asset assignment:', error);
      throw error;
    }
  },

  // Get assignment statistics
  getAssignmentStats: async () => {
    try {
      const response = await api.get('/asset-assignments/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching asset assignment statistics:', error);
      throw error;
    }
  },

  // Get next assignment code
  getNextAssignmentCode: async () => {
    try {
      const response = await api.get('/asset-assignments/next-code');
      return response.data;
    } catch (error) {
      console.error('Error fetching next assignment code:', error);
      throw error;
    }
  }
};

export default assetAssignmentService;
